"use client";

import styled from "styled-components";
import { defaultTheme } from "../../styles/defaultTheme";
import { sizes, shadow } from "../../styles/globalsStyles";

export const StyledNavbar = styled.div<{ $isMobile: boolean }>`
  height: ${sizes.navbarHeight}px;
  border-bottom: 2px solid ${defaultTheme.tertiaryColor};
  background-color: #fff;
  ${shadow}
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
